<template>
  <div class="login">
    <div class="login__window">
      <div class="login__gradient"></div>
      <div class="login__window-wrapper">
        <div class="login__logo">
          <img src="@/assets/chatbotspl_logo_blue.png" alt="Logo" />
        </div>
        <div class="login__form">
          <div class="login__inputs">
            <div class="login__username margins">
              <in
                class="login__input"
                type="text"
                v-model="loginData.username"
                @keyup="onKeyUp"
                :label="$t('view.login.usernameLabel')"
              ></in>
            </div>
            <div class="login__password">
              <in
                class="login__input"
                type="password"
                v-model="loginData.password"
                @keyup="onKeyUp"
                :label="$t('view.login.passwordLabel')"
              ></in>
            </div>
          </div>
        </div>
        <div class="login__button-container">
          <btn class="login__button" @click="logIn" icon="lock">{{
            $t("view.login.loginButton")
          }}</btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import store from "@/store";

export default {
  data() {
    return {
      loginData: {
        username: "",
        password: "",
      },
    };
  },
  methods: {
    async logIn() {
      try {
        if (!this.loginData.username || !this.loginData.password) return;
        const user = await axios.post("/api/auth/user", this.loginData);
        localStorage.setItem("user", JSON.stringify(user.data.user));
        localStorage.setItem("locale", user.data.user.admin.locale);
        localStorage.setItem("tokenExp", +new Date(user.data.expires));
        store.commit("LOGIN_USER");
        this.$store.dispatch("loadUsersGroups");
        this.$store.dispatch("loadAttachments");
        this.$store.dispatch("loadVersion");
        router.push("/");
      } catch (e) {
        this.$notify({
          title: this.$t("view.login.error.title"),
          text: this.$t(`view.login.error[${e.response.status}]`),
          type: "error",
        });
      }
    },

    onKeyUp(e) {
      if (e.key !== "Enter") return;
      this.logIn();
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  align-items: center;
  justify-content: center;

  &__window {
    @include boxShadow(0px, 2px, 8px, -4px, rgba(0, 0, 0, 0.75));
    background-color: white;
    border-radius: 4px;
  }

  &__window-wrapper {
    padding: 15px 25px;
  }

  &__logo {
    width: 85px;
    margin: 5px auto 10px auto;

    & > img {
      width: 100%;
    }
  }

  &__gradient {
    background-color: $primary;
    height: 8px;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    background-position: right bottom;
    background-repeat: repeat;
  }

  &__form {
    margin-top: 28px;
  }

  &__input {
    width: 250px;
  }

  &__button-container {
    @include alignedFlex(center);
    margin-top: 20px;
  }
}

.margins {
  margin-bottom: 15px;
}
</style>
